//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from "@/javascript/util";
import mapUtil from '@/javascript/mapUtil'
import goBack from '@/components/public-components/goBack/index.vue'
import Footer from "@/components/lyx-components/lyx-footer/index"
import weather from "@/views/lyx-pages/weather/index"

export default {
  components: {

      goBack,
      Footer,
      weather
  },
  data () {
    
    return {
      url: '',
      ermBox: false,
      //   wxLink: false,
      isWeixin: util.isWeiXin(),
      activeIndex: '',
      location: {},
      minHeight: 0,
    }
  },

  created () {
    this.minHeight = document.documentElement.clientHeight
    let ua = navigator.userAgent.toLowerCase();
    document.title = '城市服务'
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          console.log("在小程序里");
          //   this.wxLink = true;
        } else {
          console.log("不在小程序里");
        }
      });
    } else {
      //   this.wxLink = false;
      console.log("不在微信里");
    }
    if (!util.isWeiXin()) {
      mapUtil.locate(
        (data) => {
          this.locationResult(data)
        },
        (data) => {
          this.locationResult(data)
        }
      ); // 获取当前位置经纬度
    } else if (util.isWeiXin()) {
        // 微信签名分享
          const shareData = typeof (shareData) === 'undefined' ? {
            title: this.PAGE_TITLE + "导览",
            desc: '圣湖之光，大景海晏，海晏欢迎您~~',
            imgUrl: window.location.origin + '/static/-img/banner_img.png',
            link: window.location.href
          } : shareData;
          this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href) + '&appId=' + this.WX_APPID).then((response) => {
            
          util.initWxConfig(response.data.data, shareData);
          mapUtil.locate(
            (data) => {
              this.locationResult(data);
            },
            (data) => {
              this.locationResult(data);
            }
          ); // 获取当前位置经纬度
        });
    }
  },

  mounted () {

  },

  methods: {
    locationResult (val) {
      this.location = val
    },

    ydClick (i) {
      this.activeIndex = i
      if (this.isWeiXin) {
        alert('请在微信环境中打开！')
      } else {
        this.ermBox = true
      }
    },
    closeClick () {
      this.ermBox = false
    },

    goMap () {
      location.href = "https://map.qq.com/m/nearby/result/word=%E5%85%AC%E4%BA%A4" + '&centerX=' + this.location.position.lng + '&centerY=' + this.location.position.lat
    },

    toJp () {
      location.href = "https://m.ctrip.com/html5/flight/swift/index"
    },
    toWzcx () {
      location.href = " https://bl.cx580.com/content/index.html#/carService"
    },
    toQcp () {
      location.href = " https://m.ctrip.com/webapp/bus/"
    },
    handleErrorFn (e) {
      console.log("fail", e.detail);
    },
    handleLaunchFn (e) {
      console.log("success");
    },
  }
}
